module.exports = __webpack_public_path__ + "img/status_load_systems.b95c29b1.gif";